import React from 'react';
import type { ISnapIcon } from '../icons-mapper';

export const HomeSolid = (props: ISnapIcon) => {
  const { size, title, color = 'currentColor' } = props;

  return (
    <svg
      viewBox='0 0 20 20'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
      height={size}
      width={size}
    >
      <title>{title}</title>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.29303 2.29303C9.48056 2.10556 9.73487 2.00024 10 2.00024C10.2652 2.00024 10.5195 2.10556 10.707 2.29303L17.707 9.29303C17.8468 9.43288 17.942 9.61105 17.9806 9.805C18.0192 9.99895 17.9994 10.2 17.9237 10.3827C17.848 10.5654 17.7199 10.7215 17.5555 10.8314C17.3911 10.9413 17.1978 11 17 11H16V17C16 17.2652 15.8947 17.5196 15.7071 17.7071C15.5196 17.8947 15.2652 18 15 18H13C12.7348 18 12.4805 17.8947 12.2929 17.7071C12.1054 17.5196 12 17.2652 12 17V14C12 13.7348 11.8947 13.4805 11.7071 13.2929C11.5196 13.1054 11.2652 13 11 13H9.00003C8.73481 13 8.48046 13.1054 8.29292 13.2929C8.10539 13.4805 8.00003 13.7348 8.00003 14V17C8.00003 17.2652 7.89467 17.5196 7.70714 17.7071C7.5196 17.8947 7.26525 18 7.00003 18H5.00003C4.73481 18 4.48046 17.8947 4.29292 17.7071C4.10539 17.5196 4.00003 17.2652 4.00003 17V11H3.00003C2.80228 11 2.60898 10.9413 2.44457 10.8314C2.28016 10.7215 2.15202 10.5654 2.07635 10.3827C2.00068 10.2 1.98088 9.99895 2.01945 9.805C2.05802 9.61105 2.15322 9.43288 2.29303 9.29303L9.29303 2.29303Z'
      />
    </svg>
  );
};
